export const convertToNumber = (value: string): number | false => {
  const number = Number(value);
  return !Number.isNaN(number) ? number : false;
};
